/**
 * Página /tenant/calendar - Calendário Global
 *
 * A partir da v2.0.0 esta página é apenas o "shell" da rota: todo o conteúdo
 * (toolbar, sidebar de calendários, filtros, FullCalendar, modais) vive em
 * `CalendarWorkspace`, que também é reaproveitado pelo modal de calendário
 * aberto a partir do chat.
 *
 * RELEASE:
 *   2026-08-06 v2.0.0 - Corpo extraído para CalendarWorkspace (reuso em modal)
 *   2026-07-25 v1.8.0 - Ver histórico completo em CalendarWorkspace.tsx
 */

import { ModularLayout } from '@/components/layouts/ModularLayout';
import { CalendarWorkspace } from '@/components/calendar/CalendarWorkspace';

export default function TenantCalendarPage() {
  return (
    <ModularLayout>
      <CalendarWorkspace />
    </ModularLayout>
  );
}
